import React, { useState, useEffect } from 'react'
import { Row, Col, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { TextField } from '@material-ui/core';
import MenuItem from '@mui/material/MenuItem';
import CrearUsuario from '../../../components/buttons/crearUsuario';
import { Autocomplete } from '@material-ui/lab';
//Redux
import { connect } from 'react-redux';

// Componets
import Loading from '../../../components/modales/loadingModal';

//API Calls
import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const listadoCentrosCostos = functionsHttpsCallable('ape_listadoCentroCostosExistentes');
const editarFlujoAPI = functionsHttpsCallable('ape_editarFlujo');
const eliminarFlujoAPI = functionsHttpsCallable('ape_eliminarFlujo');


const mapStateToProps = state => ({
    usuarioActivo: state
})

let BodyBuscarFlujo = (props) => {
    const [listado, setListado] = useState([]);
    const [centroCosto, setCentroCosto] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [validacion, setValidacion] = useState(true);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));

    useEffect(() => {
        const getListadoCentroCostos = async () => {
            try {
                setIsLoading(true)
                const reqListado = await listadoCentrosCostos({
                    cod_empr: userData.codigoEmpresa,
                })
                setListado(reqListado.data.data)
                setIsLoading(false)
            }
            catch (error) {
                console.log(error)
            }
        }
        getListadoCentroCostos()
    }, []);

    const eliminarFlujo = async () => {
        props.toggleLoading()
        const body =
        {
            cod_empr: userData.codigoEmpresa,
            idCentroCosto: centroCosto.idCentroCosto
        }
        const deleteReq = await eliminarFlujoAPI(body)
        if (deleteReq.data.status === 'FLUJO_ELIMINADO') {
            props.toggleLoading()
            props.toastSuccess('Flujo eliminado con exito!');
            props.toggle()
        }
        else if (deleteReq.data.status === 'FLUJO_NO_EXISTE') {
            props.toggleLoading()
            props.toastError('no existe flujo para este centro de costo');
        }
        else {
            props.toggleLoading()
            props.toastError('Ocurrió un error');
        }
    }

    const editarFlujo = async () => {
        props.toggleLoading()
        const body =
        {
            cod_empr: userData.codigoEmpresa,
            idCentroCosto: centroCosto.idCentroCosto,
            data: centroCosto
        }
        const updateReq = await editarFlujoAPI(body)
        if (updateReq.data.status === 'FLUJO_ACTUALIZADO') {
            props.toggleLoading()
            props.toastSuccess('Flujo actualizado con exito!');
            props.toggle()
        }
        else if (updateReq.data.status === 'FLUJO_NO_EXISTE') {
            props.toggleLoading()
            props.toastError('no existe flujo para este centro de costo');
        }
        else {
            props.toggleLoading()
            props.toastError('Ocurrió un error');
        }
    }

    const getValidacion = () => {
        if (centroCosto.tipo === 'admin') {
            setValidacion(false)
        }
        else {
            let val = true
            Object.keys(centroCosto).forEach((key) => {
                val = val && (centroCosto[key] !== undefined && centroCosto[key] !== 0 && centroCosto[key] !== '')
            })
            setValidacion(!val)
        }
    }

    const updateCentroCosto = (key, value) => {
        const tempObj = centroCosto
        tempObj[key] = value
        setCentroCosto({...tempObj})
    }

    if (isLoading) {
        return (
            <div className={"loading-area"}><Loading /></div>
        )
    }
    else return (
        <div>
            <div>
                <Row className='user-mail-modal'>
                    <Col lg='8' md='8' xs="12">
                        <Autocomplete
                            variant='outlined'
                            required
                            margin="dense"
                            options={listado}
                            key={`key_centro_costos`}
                            id={`select_centro_costos`}
                            onChange={(event, newValue) => {
                                setCentroCosto({ ...newValue })}}
                            renderInput={(params) => (
                                <TextField {...params} variant='outlined' label='Centro de Costos' margin="normal" />
                            )}
                            getOptionLabel={(option) => option.nombreCentroCosto}
                            renderOption={(option) => (
                                <React.Fragment>
                                    {option.nombreCentroCosto}
                                </React.Fragment>
                            )}
                        />
                    </Col>
                    <Col lg='4' md='4' xs="12">
                        <TextField
                            disabled
                            variant='outlined'
                            required
                            autoComplete='off'
                            key={`key_tipo`}
                            id={`input_tipo`}
                            fullWidth
                            value={centroCosto.tipo ?? 'Sin información'}
                            label='Tipo de flujo'
                            margin="normal"
                        >
                        </TextField>
                    </Col>
                </Row>
                {centroCosto.tipo === 'operativo' ?
                    <div><Row>
                        <Col lg='12' style={{ marginTop: '5px' }}>
                            <Breadcrumb>
                                <BreadcrumbItem className='BreadcrumbItem-color'>Primer Aprobador</BreadcrumbItem>
                            </Breadcrumb>
                        </Col>
                    </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_1apr_id`}
                                    id={`cedulaPrimerAprobador`}
                                    fullWidth
                                    value={centroCosto.cedulaPrimerAprobador??'Sin información'}
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, parseInt(e.target.value)) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_1apr_name`}
                                    id={`nombrePrimerAprobador`}
                                    fullWidth
                                    value={centroCosto.nombrePrimerAprobador??'Sin información'}
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_1apr_email`}
                                    id={`emailPrimerAprobador`}
                                    fullWidth
                                    value={centroCosto.emailPrimerAprobador??'Sin información'}
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_1apr_pos`}
                                    id={`cargoPrimerAprobador`}
                                    fullWidth
                                    value={centroCosto.cargoPrimerAprobador??'Sin información'}
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Segundo Aprobador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_2apr_id`}
                                    id={`cedulaSegundoAprobador`}
                                    fullWidth
                                    value={centroCosto.cedulaSegundoAprobador??'Sin información'}
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, parseInt(e.target.value)) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_2apr_name`}
                                    id={`nombreSegundoAprobador`}
                                    fullWidth
                                    value={centroCosto.nombreSegundoAprobador??'Sin información'}
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_2apr_email`}
                                    id={`emailSegundoAprobador`}
                                    fullWidth
                                    value={centroCosto.emailSegundoAprobador??'Sin información'}
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_2apr_pos`}
                                    id={`cargoSegundoAprobador`}
                                    fullWidth
                                    value={centroCosto.cargoSegundoAprobador??'Sin información'}
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Tercer Aprobador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_3apr_id`}
                                    id={`cedulaTercerAprobador`}
                                    fullWidth
                                    value={centroCosto.cedulaTercerAprobador??'Sin información'}
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, parseInt(e.target.value)) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_3apr_name`}
                                    id={`nombreTercerAprobador`}
                                    fullWidth
                                    value={centroCosto.nombreTercerAprobador??'Sin información'}
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_3apr_email`}
                                    id={`emailTercerAprobador`}
                                    fullWidth
                                    value={centroCosto.emailTercerAprobador??'Sin información'}
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_3apr_pos`}
                                    id={`cargoTercerAprobador`}
                                    fullWidth
                                    value={centroCosto.cargoTercerAprobador??'Sin información'}
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Cuarto Aprobador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_4apr_id`}
                                    id={`cedulaCuartoAprobador`}
                                    fullWidth
                                    value={centroCosto.cedulaCuartoAprobador??'Sin información'}
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, parseInt(e.target.value)) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_4apr_name`}
                                    id={`nombreCuartoAprobador`}
                                    fullWidth
                                    value={centroCosto.nombreCuartoAprobador??'Sin información'}
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_4apr_email`}
                                    id={`emailCuartoAprobador`}
                                    fullWidth
                                    value={centroCosto.emailCuartoAprobador??'Sin información'}
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_4apr_pos`}
                                    id={`cargoCuartoAprobador`}
                                    fullWidth
                                    value={centroCosto.cargoCuartoAprobador??'Sin información'}
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Reclutador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_recl_id`}
                                    id={`cedulaReclutador`}
                                    fullWidth
                                    value={centroCosto.cedulaReclutador??'Sin información'}
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, parseInt(e.target.value)) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_recl_name`}
                                    id={`nombreReclutador`}
                                    fullWidth
                                    value={centroCosto.nombreReclutador??'Sin información'}
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_recl_email`}
                                    id={`emailReclutador`}
                                    fullWidth
                                    value={centroCosto.emailReclutador??'Sin información'}
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_recl_pos`}
                                    id={`cargoReclutador`}
                                    fullWidth
                                    value={centroCosto.cargoReclutador??'Sin información'}
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Confirmación Fecha Ingreso</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_cont_id`}
                                    id={`cedulaConfirmacionFecha`}
                                    fullWidth
                                    value={centroCosto.cedulaConfirmacionFecha??'Sin información'}
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, parseInt(e.target.value)) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_cont_name`}
                                    id={`nombreConfirmacionFecha`}
                                    fullWidth
                                    value={centroCosto.nombreConfirmacionFecha??'Sin información'}
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_cont_email`}
                                    id={`emailConfirmacionFecha`}
                                    fullWidth
                                    value={centroCosto.emailConfirmacionFecha??'Sin información'}
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_cont_pos`}
                                    id={`cargoConfirmacionFecha`}
                                    fullWidth
                                    value={centroCosto.cargoConfirmacionFecha??'Sin información'}
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Cargue Documentos</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_cont_id`}
                                    id={`cedulaCargaDocumentos`}
                                    fullWidth
                                    value={centroCosto.cedulaCargaDocumentos??'Sin información'}
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, parseInt(e.target.value)) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_cont_name`}
                                    id={`nombreCargaDocumentos`}
                                    fullWidth
                                    value={centroCosto.nombreCargaDocumentos??'Sin información'}
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_cont_email`}
                                    id={`emailCargaDocumentos`}
                                    fullWidth
                                    value={centroCosto.emailCargaDocumentos??'Sin información'}
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_cont_pos`}
                                    id={`cargoCargaDocumentos`}
                                    fullWidth
                                    value={centroCosto.cargoCargaDocumentos??'Sin información'}
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg='12' style={{ marginTop: '5px' }}>
                                <Breadcrumb>
                                    <BreadcrumbItem className='BreadcrumbItem-color'>Contratador</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                        <Row className='user-mail-modal'>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_cont_id`}
                                    id={`cedulaContratador`}
                                    fullWidth
                                    value={centroCosto.cedulaContratador??'Sin información'}
                                    label='Cédula'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, parseInt(e.target.value)) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_cont_name`}
                                    id={`nombreContratador`}
                                    fullWidth
                                    value={centroCosto.nombreContratador??'Sin información'}
                                    label='Nombre'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    key={`key_cod_cont_email`}
                                    id={`emailContratador`}
                                    fullWidth
                                    value={centroCosto.emailContratador??'Sin información'}
                                    label='Email'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                            <Col lg='6' md='6' xs="12">
                                <TextField
                                    variant='outlined'
                                    required
                                    autoComplete='off'
                                    key={`key_cod_cont_pos`}
                                    id={`cargoContratador`}
                                    fullWidth
                                    value={centroCosto.cargoContratador??'Sin información'}
                                    label='Cargo'
                                    margin="normal"
                                    onChange={(e) => { updateCentroCosto(e.target.id, e.target.value) }}
                                />
                            </Col>
                        </Row>
                    </div> : null}
                <Row>
                    <Col lg='12' md='12' xs="12" className='user-create-button'>
                        <CrearUsuario
                            onClick={() => eliminarFlujo()}
                            disabled={Object.keys(centroCosto).length < 1}
                            color='error'
                            tittle='Eliminar'
                        />
                        <CrearUsuario
                            onClick={() => editarFlujo()}
                            disabled={false}
                            tittle='Actualizar'
                        />
                    </Col>
                </Row>
            </div>
        </div>
    );
}
export default connect(mapStateToProps)(BodyBuscarFlujo);